import { Edit } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useState } from 'react'

import { RepairOrderExpanded } from '../../../sdk'
import {
  EditDiscountDialogProps,
  EditDiscountDialogUI
} from '../Discount/EditDiscountDialogUI'

export const EditDiscountButton = ({
  repairOrder
}: {
  repairOrder: RepairOrderExpanded
}) => {
  const [editDiscountDialogProps, setEditDiscountDialogProps] =
    useState<EditDiscountDialogProps>()
  return (
    <>
      {editDiscountDialogProps && (
        <EditDiscountDialogUI
          {...editDiscountDialogProps}
          setCustomProps={setEditDiscountDialogProps}
        />
      )}
      <IconButton
        size="small"
        onClick={(event) => {
          event.stopPropagation()
          setEditDiscountDialogProps({
            repairOrderEntry: repairOrder.entry!
          })
        }}>
        <Edit />
      </IconButton>
    </>
  )
}
